import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '../store/index.js'
// const routerPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
// 	return routerPush.call(this, location).catch(error => error)
// }
import {
	MessageBox
} from 'element-ui';
import Home from '../views/Home.vue'
import Learndetail from '../views/Learn-detail.vue'
// import User from '../views/User.vue'
Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: 'Home',
	meta: {
		title: "数智方舟",
		titles: "数智方舟"

	},
	component: Home,

},
{
	path: '/Resource',
	name: '/Resource',
	meta: {
		title: "方舟资讯",
		keepAlive: true,
		isBack: false,
		titles: "方舟资讯"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Resource.vue'),

},
{
	path: '/Resource',
	name: '/Resource',
	meta: {
		title: "商财资讯",
		keepAlive: true,
		isBack: false,
		titles: "商财资讯"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Resource.vue'),

},
{
	path: '/Study-detail',
	name: 'Study-detail',
	meta: {
		title: "详情",
		titles: "详情"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Study-detail.vue'),

},
{
	path: '/Practice',
	name: 'Practice',
	meta: {
		title: "活动沙龙",
		keepAlive: true,
		isBack: false,
		titles: "活动沙龙"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Practice.vue'),

},
{
	path: '/Activity',
	name: 'Activity',
	meta: {
		title: "活动沙龙详情",
		keepAlive: true,
		isBack: false,
		titles: "活动沙龙详情"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Activity.vue'),

},
{
	path: '/Learn',
	name: 'Learn',
	meta: {
		title: "课程中心",
		keepAlive: true,
		isBack: false,
		titles: "课程中心"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Learn.vue'),

},


{
	path: '/Learn-detail',
	name: 'Learn-detail',
	meta: {
		title: "学习详情",
		titles: "学习详情",


	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	// component: () => import( /* webpackChunkName: "about" */ '../views/Learn-detail.vue')
	component: Learndetail,

},


{
	path: '/User',
	name: 'User',
	meta: {
		title: "个人中心",
		keepAlive: true,
		isBack: false,
		titles: "个人中心"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/User.vue'),
	// component: User,
	beforeEnter: (to, from, next) => {
		console.log(to);
		console.log(from);

		if (to.name == 'User') {
			let token = localStorage.getItem('AccessToken');
			if (token) {
				next()
			} else {
				MessageBox.confirm('您还未登录请先登录?', '提示', {
					confirmButtonText: '去登录',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					router.push("/Login")
				}).catch(() => {
					router.go(0)
				});

			}

		}
	}
},
{
	path: '/About',
	name: 'About',
	meta: {
		title: "关于星辰",
		keepAlive: true,
		isBack: false,
		titles: "关于星辰"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/About.vue'),
	// component: User,
	// beforeEnter: (to, from, next) => {

	// 	let token = localStorage.getItem('AccessToken')
	// 	if (token) {
	// 		next()
	// 	} else {
	// 		MessageBox.confirm('您还未登录请先登录?', '提示', {
	// 			confirmButtonText: '去登录',
	// 			cancelButtonText: '取消',
	// 			type: 'warning'
	// 		}).then(() => {
	// 			router.push("/Login")
	// 		}).catch(() => {
	// 			router.go(0)
	// 		});

	// 	}

	// }
},
{
	path: '/Login',
	name: 'Login',
	meta: {
		title: "登录",
		titles: "登录"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Login.vue')
},
{
	path: '/Register',
	name: 'Register',
	meta: {
		title: "注册",
		titles: "注册"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Register.vue')
},
{
	path: '/Find',
	name: 'Find',
	meta: {
		title: "忘记密码",
		titles: "忘记密码"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Find.vue'),

},

{
	path: '/success',
	name: 'success',
	meta: {
		title: "支付成功",
		titles: "支付成功"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/success.vue')
},
{
	path: '/Img',
	name: 'Img',
	meta: {
		title: "详情",
		titles: "详情"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Img.vue')
},
{
	path: '/alipay',
	name: 'alipay',
	meta: {
		title: "支付宝支付",
		titles: "支付宝支付"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/alipay.vue')
},
{
	path: '/legal',
	name: 'legal',
	meta: {
		title: "法律声明",
		keepAlive: true,
		isBack: false,
		titles: "法律声明"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/legal.vue'),

},
{
	path: '/contactus',
	name: 'contactus',
	meta: {
		title: "联系我们",
		keepAlive: true,
		isBack: false,
		titles: "联系我们"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/contactus.vue'),

},

{
	path: '/privacy',
	name: 'privacy',
	meta: {
		title: "隐私条款",
		keepAlive: true,
		isBack: false,
		titles: "隐私条款"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/privacy.vue'),

},

{
	path: '/service',
	name: 'service',
	meta: {
		title: "服务条款",
		keepAlive: true,
		isBack: false,
		titles: "服务条款"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/service.vue'),

},

{
	path: '/Learn-detailcopy',
	name: 'Learn-detailcopy',
	meta: {
		title: "学习详情",
		keepAlive: true,
		isBack: false,
		titles: "学习详情"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Learn-detailcopy.vue'),

},
{
	path: '/Examcopy',
	name: 'Examcopy',
	meta: {
		title: "测试",
		keepAlive: true,
		isBack: false,
		titles: "测试"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Examcopy.vue'),

},
{
	path: '/Exam',
	name: 'Exam',
	meta: {
		title: "考试",
		keepAlive: true,
		isBack: false,
		titles: "考试"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Exam.vue'),

},
{
	path: '/Exam-detail',
	name: 'Exam-detail',
	meta: {
		title: "测试详情",
		titles: "测试详情"

	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/Exam-detail.vue'),
},
{
	path: '/Datum',
	name: 'Datum',
	meta: {
		title: "解决方案",
		keepAlive: true,
		isBack: false,
		titles: "解决方案"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/datum.vue'),

},
{
	path: '/read',
	name: 'read',
	meta: {
		title: "阅读",
		keepAlive: true,
		isBack: false,
		titles: "阅读"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/read.vue'),
},
{
	path: '/null',
	name: 'null',
	meta: {
		title: "首页",
		keepAlive: true,
		isBack: false,
		titles: "首页"
	},
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "about" */ '../views/null.vue'),
},
{
	path: '/Survey',
	name: 'Survey',
	meta: {
		title: "问卷调研",
		keepAlive: true,
		isBack: false,
		titles: "问卷调研"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/Survey.vue'),

},
{
	path: '/Survey-detail',
	name: 'Survey-detail',
	meta: {
		title: "问卷调研",
		keepAlive: true,
		isBack: false,
		titles: "问卷调研"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/Survey-detail.vue'),

},
{
	path: '/Survey-detail-my',
	name: 'Survey-detail-my',
	meta: {
		title: "问卷调研",
		keepAlive: true,
		isBack: false,
		titles: "问卷调研"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/Survey-detail-my.vue'),

},
{
	path: '/Expert',
	name: 'Expert',
	meta: {
		title: "专家专栏",
		keepAlive: true,
		isBack: false,
		titles: "专家专栏"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/expert/index.vue'),

},
{
	path: '/specialDetail',
	name: 'specialDetail',
	meta: {
		title: "专栏详情",
		titles: "专栏详情"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/specialDetail.vue'),
},
{
	path: '/expertDetail',
	name: 'expertDetail',
	meta: {
		title: "专家详情",
		titles: "专家详情"
	},
	component: () => import( /* webpackChunkName: "about" */ '../views/expertDetail.vue'),
}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
